module.exports = __webpack_public_path__ + "img/facebook.70d31d74.svg";